<app-content>
  <app-breadcrumbs>
    <li>
      Moje dane
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Moje dane
    </h2>
    @if (!isCompletedUserData() && !loading()) {
      <app-alert type='info' [closable]='false'>
        Jeśli chcesz w pełni korzystać z e-portalu i procedować sprawy, musisz wypełnić swoje dane oraz zaakceptować regulamin i wyrazić zgodę na przetwarzanie danych osobowych (RODO). Wymagane pola odznaczone "<strong>*</strong>".
      </app-alert>
    }
    <app-alert-container></app-alert-container>
    <form novalidate [formGroup]='form' (ngSubmit)='onSubmit()' *ngIf='!loading() && !pending()'>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"firstName" as controlName'>
            <label [for]='controlName'>
              Imię
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu imię/imiona'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"lastName" as controlName'>
            <label [for]='controlName'>
              Nazwisko
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwisko'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"phoneNumber" as controlName'>
            <label [for]='controlName'>
              Numer telefonu
            </label>
            <input
              mask='0*'
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu numer telefonu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"email" as controlName'>
            <label [for]='controlName'>
              E-mail *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu e-mail'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"postalCode" as controlName'>
            <label [for]='controlName'>
              Kod pocztowy
            </label>
            <input
              [id]='controlName'
              mask='00-000'
              [dropSpecialCharacters]='false'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu kod pocztowy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"postOffice" as controlName'>
            <label [for]='controlName'>
              Poczta
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu pocztę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu miejscowość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"houseNumber" as controlName'>
            <label [for]='controlName'>
              Nr domu
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr domu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
            <label [for]='controlName'>
              Nr mieszkania
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr mieszkania'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <br>
      <div class='row'>
        <div class='col-12'>
          <app-accordion-group>
            <app-accordion-item [expanded]='true' name='Regulamin'>
              <ng-container *ngIf='subpages() | subpageContentByUrl: "regulamin" as subpage'>
                <div class="editor-content" [innerHTML]='subpage?.content'></div>
              </ng-container>
            </app-accordion-item>
          </app-accordion-group>
          <br>
          <div class='form-group' *ngIf='"termsConsent" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                * Zapoznałem/am się z regulaminem e-usługi
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
          <app-accordion-group>
            <app-accordion-item [expanded]='true' name='Klauzula RODO'>
              <ng-container *ngIf='subpages() | subpageContentByUrl: "rodo" as subpage'>
                <div class="editor-content" [innerHTML]='subpage?.content'></div>
              </ng-container>
            </app-accordion-item>
          </app-accordion-group>
          <br>
          <div class='form-group' *ngIf='"gdprConsent" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                * Zapoznałem/am się z klauzulą informacyjną RODO
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-12'>
          <div class='form-group' *ngIf='"notificationsConsent" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Chcę otrzymywać powiadomienia na adres e-mail
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class='form-actions' *ngIf='form.disabled'>
        <a routerLink='../' class='btn btn-secondary'>Powrót</a>
        <button type='button' class='btn btn-primary' (click)='form.enable()'>Edytuj</button>
      </div>
      <div class='form-actions' *ngIf='form.enabled'>
        <button type='button' class='btn btn-secondary' (click)='patchForm()'>
          Anuluj
        </button>
        <button type='submit' class='btn btn-primary' [disabled]='pending()'>Zapisz</button>
      </div>
    </form>
    <app-spinner *ngIf='pending()'>
      Poczekaj trwa zapisywania danych...
    </app-spinner>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
